import {Box, Typography} from '@mui/material';

import {WorkforceProfileHighlightItem} from './WorkforceProfileHighlightItem';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import type {WorkforceProfileHighlightVariant} from '../../utils/WorkforceProfileDetail/getWorkforceProfileHighlightDotColor';

export interface Props {
  title: string;
  items: string[];
  variant: WorkforceProfileHighlightVariant;
  columns?: 1 | 2;
  footer?: React.ReactNode;
}

export const WorkforceProfileHighlightList = ({title, items, variant, columns = 1, footer}: Props) => (
  <EmpionPaper sx={{border: `1px solid ${orangeColors[3]}`, borderRadius: '14px', p: 2.5}}>
    <Typography variant='h3' sx={{fontWeight: 600, mb: 1.5}}>
      {title}
    </Typography>
    {items.length === 0 ? (
      <Typography variant='body2' color='text.secondary'>
        —
      </Typography>
    ) : (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: columns === 2 ? {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))'} : '1fr',
          columnGap: 2,
          rowGap: columns === 2 ? 0.5 : 0,
        }}
      >
        {items.map((item, index) => (
          <WorkforceProfileHighlightItem
            key={item}
            item={item}
            variant={variant}
            showDivider={columns === 1 && index < items.length - 1}
          />
        ))}
      </Box>
    )}
    {footer}
  </EmpionPaper>
);
